import styled from '@emotion/styled';

const CellList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4.8vw;
  @media (orientation: landscape) {
    flex-direction: row;
    justify-content: space-between;
    gap: 0;
  }
`;

export { CellList };